// extracted by mini-css-extract-plugin
export default {"root":"Page404_root__kKBuC","container":"Page404_container__Lj+5p","title":"Page404_title__dLXQK","txt1":"Page404_txt1__zKHLf","link":"Page404_link__9lEWL"};